<div class="summary-metrics-section">
  <div class="max-w-7xl mx-auto px-3 mb-4">
    <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-3">
      <div
        *ngFor="let card of summaryCards; let i = index"
        [ngStyle]="{'animation-delay': (i * 0.1) + 's', 'border-left': '4px solid ' + card.borderColor, 'background-color': card.bgColor}"
        class="rounded-lg shadow px-4 py-3 animate-fadeInUp hover:shadow-md transition"
      >
        <!-- Top Row -->
        <div class="flex items-start justify-between mb-1">
          <div class="flex items-center gap-2">
            <span class="rounded-full p-1.5 flex items-center justify-center" [ngStyle]="{'background-color': card.bgColor}">
              <i [class]="card.icon" [ngStyle]="{'color': card.iconColor}" class="text-base"></i>
            </span>
            <div>
              <div class="text-xs font-medium text-gray-600">{{ card.label }}</div>
              <div class="font-bold text-gray-900 text-lg">{{ card.count }}</div>
            </div>
          </div>
        </div>

        <!-- Scheme Breakdown -->
        <div *ngIf="card.schemeBreakdown && card.schemeBreakdown.length > 0" 
             class="mt-1 pt-1 border-t border-gray-100">
          <div class="text-[13px] text-gray-600 leading-tight whitespace-nowrap overflow-x-hidden">
            <span *ngFor="let scheme of card.schemeBreakdown; let last = last; let idx = index">
              <span [ngClass]="{
                'text-blue-600 font-semibold': idx === 0,
                'text-green-600 font-semibold': idx === 1,
                'text-purple-600 font-semibold': idx === 2,
                'text-orange-600 font-semibold': idx === 3
              }">
                {{ scheme.schemeName === 'makeiii' ? 'Make III' : scheme.schemeName }}:
              </span>
              <span class="font-bold text-gray-800 ml-0.5">{{ scheme.count }}</span>
              <span *ngIf="!last" class="text-gray-300 mx-1">|</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
